/*
 * The bell of a Waper who does nothing also learns of the notifications created without them: a badge given by a
 * cron (Top 10, Corner of the week…), a like or a follow received, a notification deleted by the stale purge (#1276).
 * Their own actions already read the count again (useCustomFetch, #1279); this reads it when the tab comes back into
 * view and every 2 minutes while it is visible (decision of Julien, 01/11/2026: the bell live everywhere). One light
 * GET /secure/notification/count, skipped for a visitor (fetchUnreadCount returns when not authenticated).
 */
const EVERY_MS = 2 * 60 * 1000
// a tab switched back and forth reads the count at most this often
const MIN_GAP_MS = 30 * 1000

export default defineNuxtPlugin((nuxtApp) => {
  let last = Date.now()

  const refresh = () => {
    if (document.visibilityState !== 'visible') return
    if (Date.now() - last < MIN_GAP_MS) return
    last = Date.now()
    useNotificationsStore().fetchUnreadCount()
  }

  nuxtApp.hook('app:mounted', () => {
    setInterval(refresh, EVERY_MS)
    document.addEventListener('visibilitychange', refresh)
  })
})
